const Triangle = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='10' height='20' viewBox='0 0 10 20' fill='none'>
      <path d='M10 10L-8.74228e-07 20L0 -4.37114e-07L10 10Z' fill='#262680' />
    </svg>
  )
}

export default Triangle
